<div class="sound-slider flex items-center h-24">
  <svg-icon
    (click)="toggleSound()"
    class="sound-icon flex items-center justify-center  s-16"
    [src]="value() === 0 ? 'assets/icons/ui/sound-x.svg' : 'assets/icons/ui/sound.svg'"
  />
  <div
    [(ngpSliderValue)]="value"
    ngpSlider
    ngpSliderMin="0"
    ngpSliderMax="100"
    ngpSliderStep="1"
  >
    <div ngpSliderTrack>
      <div ngpSliderRange></div>
    </div>
    <div ngpSliderThumb></div>
  </div>
</div>
